import { isContentPurchaseNotificationDetails as typeGuard } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationContentPurchase.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
